// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1cWUu","search":"Settings_search__bm7WS","filter":"Settings_filter__PERa-"};